"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingPick = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="dashboard-wrapper">
        <div class="firms-list row">
            <div class="form col-12 pb-lg-5">
                <div class="mb-2">
                    <h1>${'onboarding.pick.title'.t()}</h1>
                    <p>${'onboarding.pick.description'.t()}</p> 
                </div>

                
                <div class="mb-5">
                    <div class="row" :style="${x => x.loading ? 'display:none' : ''}">
                        ${(0, fast_element_1.repeat)(x => x.professions, (0, fast_element_1.html) `
                            <div class="col-lg-6 mb-4">
                                <div class="card p-4 pick-item">
                                    <div class="row">
                                        <div class="col-lg-7">                                            
                                            <div class="d-flex flex-wrap gap-1 h-100" style="flex-direction: column;">
                                                <h3 class="m-0">${x => x.name}</h3>
                                                
                                                ${(0, fast_element_1.when)(x => x.steps && x.steps.length > 0, (0, fast_element_1.html) `
                                                    <div class="d-flex flex-wrap my-3" style="gap:2px;">
                                                        ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
                                                            <span class="badge badge-theme-2">${x => x.title}</span>
                                                        `)}
                                                    </div>
                                                `)}
                                                
                                                ${(0, fast_element_1.when)(x => x.description, (0, fast_element_1.html) `
                                                    <p>${x => x.description}</p>
                                                `)}
                                                
                                                ${(0, fast_element_1.when)(x => x.branch, (0, fast_element_1.html) `
                                                    <div class="d-flex flex-wrap"><small class="badge badge-primary mt-1 mb-2">${x => x.branch.name}</small></div>
                                                `)}
                                                
                                                <button @click="${(x, c) => c.parent.selectProfession(x)}" class="mt-auto btn btn-primary btn-lg">
                                                    Rozpocznij
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            ${(0, fast_element_1.when)(x => x.image, (0, fast_element_1.html) `
                                                <img @click="${(x, c) => c.parent.selectProfession(x)}" src="/uploads/${x => x.image.filename}" 
                                                     class="card pick-card pick-img"
                                                     />
                                            `, (0, fast_element_1.html) `
                                                <div @click="${(x, c) => c.parent.selectProfession(x)}" class="card d-flex align-items-center justify-content-center pick-card pick-placeholder"                                                     >
                                                    <i class="iconsminds-profile" style="font-size: 80px; color: white;"></i>
                                                </div>
                                            `)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `)}
                        
                        
                        ${(0, fast_element_1.when)(x => !x.loading && !x.error && x.professions.length === 0, (0, fast_element_1.html) `
                            <div class="col-12">
                                <div class="alert alert-warning text-center" role="alert">
                                    <i class="fas fa-exclamation-triangle mr-2"></i>
                                    ${'onboarding.profession.empty'.t()}
                                </div>
                            </div>
                        `)}
                    </div>
                    

                    <div :style="${x => !x.loading ? 'display:none' : ''}" class="text-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">${'loading'.t()}</span>
                        </div>
                        <p class="mt-2">${'onboarding.pick.loading'.t()}</p>
                    </div>

                    <div :style="${x => !x.error ? 'display:none' : ''}" class="alert alert-danger" role="alert">
                        ${x => x.error}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `#etapTabs button {
  width: 100%;
}

.avatars-select {
  box-shadow: none;
  background: transparent;
  padding: 0;
  margin: 0;
  height: auto;
  cursor: pointer;
}

.avatars-select .name {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
  padding: 0.5rem 1rem;
  background: #fff;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.avatars-select:hover .name {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1), 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.avatars-select span .me-3 {
  margin-right: 0.5rem;
}

.pick-card {
  width: 100%;
  height: 300px;
  margin-top: -40px;
  object-fit: cover;
  cursor: pointer;
}
.pick-card.pick-placeholder {
  background: linear-gradient(135deg, #D0D0D0, #E7E7E7);
}

.pick-item:hover .pick-card {
  transform: translateY(-40px);
}`;
const shadowOptions = { "mode": "open" };
let OnboardingPick = class OnboardingPick extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.professions = [];
        this.loading = false;
        this.error = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
        console.log('OnboardingPick connected', this.routeParams);
    }
    async loadData() {
        try {
            this.loading = true;
            this.error = '';
            // Load professions with steps
            const response = await this.apiService.back.get('profession.list');
            if (response.success) {
                this.professions = response.data;
            }
            else {
                this.error = response.error || 'Failed to load professions';
            }
        }
        catch (error) {
            console.error('Error loading professions:', error);
            this.error = 'Failed to load professions';
        }
        finally {
            this.loading = false;
        }
    }
    selectProfession(profession) {
        // Navigate to onboarding wizard with selected profession
        component_1.SiteMenu.goto.bind(this)(`/onboarding/wizard/profession/${profession.id}`);
    }
};
exports.OnboardingPick = OnboardingPick;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingPick.prototype, "professions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingPick.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OnboardingPick.prototype, "error", void 0);
exports.OnboardingPick = OnboardingPick = __decorate([
    (0, client_1.RWSView)('onboarding-pick', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], OnboardingPick);
OnboardingPick.defineComponent();
